import DatePicker from "react-datepicker";
import styles from "./common.module.css";

const CustomDatePicker = ({
  dateFormat = "yyyy-MM-dd HH:mm:ss",
  onChange,
  onChangeRaw,
  selected,
  showMonthYearPicker,
  showYearDropdown,
  dropdownMode,
  minDate,
  maxDate,
  placeholderText,
  showTime = false,
  disabled = false,
}) => {
  return (
    <DatePicker
      placeholderText={placeholderText}
      dateFormat={dateFormat}
      onChange={onChange}
      onChangeRaw={onChangeRaw}
      selected={selected}
      showTimeSelect={showTime}
      timeFormat="HH:mm:ss"
      timeIntervals={15}
      showMonthYearPicker={showMonthYearPicker}
      showYearDropdown={showYearDropdown}
      dropdownMode={dropdownMode}
      minDate={minDate}
      maxDate={maxDate}
      className={styles.customDatepickerInput}
      disabled={disabled}
      readOnly={disabled}
    />
  );
};

export default CustomDatePicker;
